export class UserException extends Error {
}
